import React from 'react'
import { connect } from 'react-redux'
import { Prompt } from 'react-router-dom'
import { taskFormChangesSelector } from 'selectors'
import language from 'utils/vast-languagepack'

export default connect(
  state => ({
    taskFormChanges: taskFormChangesSelector(state),
    saveAttempted: state.tasks.addOrEdit.saveAttempted,
  }),
  null
)(({ taskFormChanges, saveAttempted }) => {
  return <Prompt when={!saveAttempted && taskFormChanges} message={language.task.add.unSavedChanges} />
})
